import React from 'react';

const ProductBenefits = props => {

  return (
    <section className="product-benefits">
      <div className="product-benefits-group">
        <div className="product-benefit-1-tagline">
          Analisi dei dati di vendita per la tua azienda
        </div>
        <div className="product-benefit-1-image"></div>
        <div className="product-benefit-2-tagline">
          Piattaforme gestionali intuitive, veloci e responsive.
        </div>
        <div className="product-benefit-2-image"></div>
        <div className="product-benefit-3-tagline">
          Generazione ed esportazione di report personalizzabili
        </div>
        <div className="product-benefit-3-image"></div>
      </div>
    </section>
  )
};

export default ProductBenefits;
